<template>
  <div v-if="visible" class="loader-content border rounded">
    <div class="loader-inner border rounded bg-white p-2">
      <ProgressSpinner style="height: 2rem" stroke-width="8" fill="transparent" :aria-label="message" />
      <div class="loader-message">{{  message  }}</div>
    </div>
  </div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';


defineProps({
  visible: {
    type: Boolean,
    required: true,
    default: false
  },
  message: {
    type: String,
    default: 'Loading...'
  }
});
</script>

<style scoped>
.loader-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
}

.loader-inner {
  display: flex;
  align-items: center;
}

.loader-message {
  margin-left: .25rem; /* Space between spinner and message */
}
</style>